export function indexOfPropertyValue(array: any[], prop: string, value: any): number {
    for (let index = 0; index < array.length; index++) {
        if (array[index][prop]) {
            if (array[index][prop] === value) {
                return index;
            }
        }
    }
    return -1;
}